import api from '~/services/api';
import { formatDateString, formatPrice } from './format';
import { sortOrdersByDate } from './sortOrdersByDate';
import SnackBar from './SnackBar';

const handleOrdersResponse = async (data, omni) => {
    let newOrderData;

    newOrderData = data.map(order => ({
        ...order,
        formatCreationDate: formatDateString(order.creationDate),
        formatInvoicedDate: formatDateString(order.invoicedDate),
        colecao: order.colecao,
        jewelValue: order.jewelValueItem,
        value: formatPrice(order.value),
        ...(omni && {
            valueAsNumber: order?.value,
            status_evento: order?.ultimo_status,
            channel:
                order?.ultimo_status === 'DEVOLUCAO'
                    ? order?.ultimo_status
                    : order?.channel,
        }),
    }));

    // FILTRANDO A RESPONSE PARA EXCLUIR CASOS DE VENDA FISICA COM VALOR ZERO. TRATANDO CASOS DE CANCELAMENTOS FISICOS FEITOS EM LOJA
    // QUE NAO DEVEM SER MOSTRADOS AO USUARIO

    newOrderData = newOrderData.filter(order => {
        if (order.value === formatPrice(0)) {
            return false;
        }
        return true;
    });

    newOrderData = sortOrdersByDate(newOrderData, false);
    
    if (newOrderData.length) {
        try {
            const clientResponse = await api.post(
                `salesperson/orders/client-data`,
                {
                    orderData: newOrderData.map(order => ({
                        orderId: order.orderId,
                        clientId: order.clientId,
                    })),
                }
            );

            newOrderData = newOrderData.map(order => ({
                ...order,
                clientData: clientResponse.data.find(
                    client =>
                        client.orderId === order.orderId &&
                        client.clientId === order.clientId
                ).clientData,
            }));
        } catch {
            SnackBar.error('Erro retornando dados do cliente');
            newOrderData = newOrderData.map(order => ({
                ...order,
                clientData: order.clientId,
            }));
        }
    }

    return newOrderData;
};

export { handleOrdersResponse };
